import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import Header from "../common/header/Header";
import { Toast } from "../common/toast/toast";
import { useDispatch, useSelector } from "react-redux";
import { getCountryStateInformation } from "../../reducer/slices/country-state/get-country-info-slice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BackButton } from "../common/back-button/back-button";
import { countryCodes } from "../common/country-selector/constant";
import CountrySelector from "../common/country-selector/country-selector";

const EditPatient = () => {
    const location = useLocation()
    const [mainData, setMainData] = useState()
    const { id } = location.state || {}
    const [addFirstName, setAddfirstName] = useState('')
    const [addLastName, setAddLastName] = useState('')
    const [addPhoneNumber, setAddPhoneNumber] = useState('')
    const [addCountryCode, setAddCountryCode] = useState('')
    const [locationId, setlocationId] = useState([]);
    const [city, setCity] = useState('')
    const [postal, setPostal] = useState('')
    const [stateList, setStateList] = useState();
    const [addAddress, setAddAddress] = useState('')
    const [genderVal, setGenderVal] = useState('')
    const [selectCountry, setSelectCountry] = useState("");
    const [selectedStateId, setSelectedStateId] = useState("")
    const [selectStateName, setSelectStateName] = useState("")
    const [selectedCountryId, setSelectedCountryId] = useState("")
    const [email, setEmail] = useState()
    const [apiLoader, setApiLoader] = useState(false)
    const [dob, setDob] = useState(null);
    const countryData = useSelector(state => state.country.countryData);
    const [toasts, setToasts] = useState([]);
    
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCountryStateInformation({}));
    }, [])

    const handleSelectCountryChange = (e) => {
        const selectedName = e.target.value; // Get the selected timezone
        setSelectCountry(selectedName)
        const selectedTimeZone = countryData.find((tz) => tz.countryName === selectedName);
        if (selectedTimeZone && selectedTimeZone.countryID) {
            setSelectedCountryId(selectedTimeZone.countryID)
        }
        if (selectedTimeZone && selectedTimeZone.stateResponseModel && selectedTimeZone.stateResponseModel.length) {
            setStateList(selectedTimeZone.stateResponseModel)
        }
        
    };

    const handleSelectStateChange = (e) => {
        const selectedName = e.target.value; // Get the selected timezone
        setSelectStateName(selectedName)
        if (countryData && countryData.length) {
            const stateAndCountryId = getCountryAndStateId(countryData, selectedName)
            if (stateAndCountryId && stateAndCountryId.countryID) {
                setSelectedCountryId(stateAndCountryId.countryID)
                setSelectedStateId(stateAndCountryId.stateID)
            }
        }
    };
    const fetchData = async () => {
        dispatch(getCountryStateInformation({}));
        const response = await axios.get(`${ENDPOINTS.PATIENT.GET_PATIENT_BY_ID}?patientID=${id}`)
            .then(
                (res) => {
                    setMainData(res.data.data)
                    const mainData = res.data.data;
                    setAddfirstName(mainData.firstName)
                    setAddLastName(mainData.lastName)
                    setAddPhoneNumber(mainData.phoneNumber);
                    setAddCountryCode(mainData.countryCode)
                    setlocationId(mainData.locationID)
                    setGenderVal(mainData.gender)
                    setDob(mainData.dob)
                    setAddAddress(mainData.address)
                    setSelectCountry(mainData.countryName)
                    handleSelectCountryChange({ target: { value: mainData.countryName } })
                    handleSelectStateChange({ target: { value: mainData.stateName } })
                    setEmail(mainData.emailAddress)
                    setSelectedCountryId(mainData.countryID)
                    setCity(mainData.city)
                    setPostal(mainData.zip)
                }

            ).catch((error) => {
               
            })
    }

    useEffect(() => {
        fetchData()
    }, [])


    useEffect(() => {
        if (mainData && mainData.stateName) {
            handleSelectStateChange({ target: { value: mainData.stateName } })
        }



    }, [selectCountry, stateList])


    const validateForm = (formData) => {
        const errors = {};

        // Validate first name
        if (!addFirstName || addFirstName.trim() === "") {
            errors.addFirstName = "First name is required.";
        } else if (addFirstName.length < 2) {
            errors.addFirstName = "First name must be at least 2 characters long.";
        }

        // Validate last name
        if (!addLastName || addLastName.trim() === "") {
            errors.addLastName = "Last name is required.";
        } else if (addLastName.length < 2) {
            errors.addLastName = "Last name must be at least 2 characters long.";
        }

        // Validate country code
        if (!addCountryCode || addCountryCode.trim() === "") {
            errors.addCountryCode = "Country code is required.";
        }


        if (!addPhoneNumber || typeof addPhoneNumber !== "string" || addPhoneNumber.trim() === "") {
            console.error("Validation Error: Empty phone number");
            errors.phoneNumber = "Phone number is required.";
        } else if (!/^\d{10}$/.test(addPhoneNumber.trim())) {
            console.error("Validation Error: Invalid phone number");
            errors.phoneNumber = "Phone number must be 10 digits.";
        }

       
        setErrors(errors)
        return errors;
    };




    function getCountryAndStateId(data, stateName) {

        // Validate input data
        if (!Array.isArray(data) || data.length === 0) {
            console.error("Invalid data: Data should be a non-empty array.");
            return null;
        }

        // Validate stateName
        if (typeof stateName !== "string" || stateName.trim() === "") {
            console.error("Invalid stateName: State name must be a non-empty string.");
            return null;
        }

        // Search for the state and country
        for (const country of data) {
            if (country.stateResponseModel && Array.isArray(country.stateResponseModel)) {
                const state = country.stateResponseModel.find(
                    (state) =>
                        typeof state.stateName === "string" &&
                        state.stateName.toLowerCase() === stateName.toLowerCase()
                );
                if (state) {
                    return {
                        countryID: country.countryID,
                        stateID: state.stateID,
                    };
                }
            } else {
                console.warn(`Invalid stateResponseModel for countryID: ${country.countryID}`);
            }
        }

        console.warn("State not found!");
        return null; // Return null if no matching state is found
    }

    const handleEditPatient = async (e) => {
        const errors = validateForm(); // Call validation function

if (Object.keys(errors).length > 0) {
    return; // Stop execution if there are errors
}
        setApiLoader(true)
        e.preventDefault();


        const responseBody = {
            "patientID": id,
            "firstName": addFirstName,
            "lastName": addLastName,
            "countryCode": addCountryCode,
            "phoneNumber": addPhoneNumber,
            "emailAddress": email,
            "locationID": locationId,
            "gender": genderVal,
            "dob": dob,
            "address": addAddress,
            "countryID": selectedCountryId,
            "stateID": selectedStateId,
            "city": city,
            "zip": postal
        }

        try {
            const response = await axios.put(ENDPOINTS.PATIENT.EDIT_PATIENT, responseBody)
            setApiLoader(false)
            addToast("The Patient details has been updated successfully!", "success")
            
            // setPopup({ show: true, message: "The Patient details has been updated successfully!", isError: false });
        }
        catch (error) {
           
            setApiLoader(false)
            addToast("Error updating patient details.", "error")
        }
    }

    const addToast = (message, type) => {
        const id = Date.now();
        setToasts([...toasts, { id, message, type }]);
        setTimeout(() => removeToast(id), 3000);
    };

    const removeToast = (id) => {
        setToasts(toasts.filter((toast) => toast.id !== id));
    };

    const gender = [
        "Male",
        "Female",
        "Transgender"]

    return (
        <>
            <Header backbutton={true} headertitle="Edit Patient Details" />
            {toasts.map((toast) => (
                <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
            ))}
            <div className="main-body p-8 pt-[36px]">

                <div >
                    <p className="font-mont text-[#373737]">Keep Patient Details Updated for Smooth Operations and Clear Communication</p>
                    <div className="grid grid-cols-2 gap-8 pt-[31px]">
                        <div>
                            <label htmlFor="firstName" className="block font-semibold title_color pb-4 font-mont">First Name <span className="aestrick_color">*</span></label>
                            <input
                                type="text"
                                id="firstname"
                                name="firstName"
                                className="  border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                required
                                defaultValue={addFirstName}
                                onChange={(e) => setAddfirstName(e.target.value)}
                            />
                            {errors.firstName && <p className="text-red-500 text-sm">{errors.firstName}</p>}
                        </div>

                        <div>
                            <label htmlFor="lastName" className="block font-semibold title_color pb-4 font-mont">Last Name <span className="aestrick_color">*</span></label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                className="  border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                required
                                defaultValue={addLastName}
                                onChange={(e) => setAddLastName(e.target.value)}
                            />
                            {errors.lastName && <p className="text-red-500 text-sm">{errors.lastName}</p>}
                        </div>


                        <div>
                            <label className="block font-semibold title_color pb-4 font-mont">Email
                                {/* <span className="aestrick_color">*</span> */}
                            </label>
                            <input
                                type="text"
                                id="countryCode"
                                name="countryCode"
                                className="  border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                defaultValue={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                        </div>
                        <div>
                            {/* <label htmlFor="phoneNumber" className="block font-semibold title_color pb-4 font-mont">Phone Number <span className="aestrick_color">*</span></label> */}
                            <CountrySelector hideFlag={false} countryCode={addCountryCode} countryCodes={countryCodes} setCountryCode={setAddCountryCode} errors={errors} setAddPhoneNumber={setAddPhoneNumber} addPhoneNumber={addPhoneNumber} />
                            {/* {errors.phoneNumber && <p className="text-red-500 text-sm">{errors.phoneNumber}</p>} */}
                        </div>
                        <div className="w-full relative">
                            <label className="block text-[16px] text-[#1B2A3D] font-mont font-[600] mb-4">Gender
                                {/* <span className="aestrick_color">*</span> */}
                            </label>
                            <select
                                id="countyr"
                                name="country"
                                value={genderVal}
                                className="  border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                                onChange={(e) => setGenderVal(e.target.value)}
                            // required
                            >
                                <option value={""} selected disabled></option>
                                {gender?.map((tz) => (
                                    <option key={tz} value={tz}>
                                        {tz}
                                    </option>
                                ))}
                            </select>
                            <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none p-[6px]">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                            {errors?.gender && <span className="text-red-500">{errors.gender}</span>}
                        </div>
                        <div>
                            <label htmlFor="dob" className="block title_color pb-4">
                                Date of Birth
                                {/* <span className="aestrick_color">*</span> */}
                            </label>
                            <div className="w-full flex relative">
                                <DatePicker
                                    selected={dob}
                                    onChange={(date) => setDob(date)}
                                    dateFormat="yyyy-MM-dd"
                                    maxDate={new Date()}
                                    showYearDropdown
                                    showMonthDropdown
                                    dropdownMode="select"
                                    placeholderText="Select your date of birth"
                                    className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                // required
                                />
                                <svg
                                    className="absolute right-3 top-3 pointer-events-none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="22"
                                    viewBox="0 0 20 22"
                                    fill="none"
                                >
                                    <path
                                        d="M17 3H3C1.89543 3 1 3.89543 1 5V19C1 20.1046 1.89543 21 3 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3Z"
                                        stroke="#245CEA"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M14 1V5"
                                        stroke="#245CEA"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M6 1V5"
                                        stroke="#245CEA"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M1 9H19"
                                        stroke="#245CEA"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            {errors?.dob && <span className="text-red-500">{errors.dob}</span>}
                        </div>
                        <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 bottom-0 w-full -ml-8 bg-white pl-8 flex gap-5 z-10">
                            <button type="submit" className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 w-[100px]" onClick={handleEditPatient} disabled={apiLoader}>{apiLoader ? <div className="flex justify-center"><div className="mini-spinner "></div></div> : "Update"}</button>
                            <BackButton />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-8 mt-8">
                        <div className="w-full relative">
                            <label className="block text-[16px] text-[#1B2A3D] font-mont font-[600] mb-3">Country/Region
                                {/* <span className="aestrick_color">*</span> */}
                            </label>
                            <select
                                id="countyr"
                                name="country"
                                value={selectCountry}
                                className="  border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                                onChange={handleSelectCountryChange}
                            >
                                <option value={""} selected disabled></option>
                                {countryData?.map((tz) => (
                                    <option key={tz.countryID} value={tz.countryName}>
                                        {tz.countryName}
                                    </option>
                                ))}
                            </select>
                            <span className="absolute right-4 top-[60px] transform -translate-y-1/2 pointer-events-none p-[6px]">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        </div>
                        <div className="w-full relative">
                            <label className="block text-[16px] text-[#1B2A3D] font-mont font-[600] mb-3">State
                                {/* <span className="aestrick_color">*</span> */}
                            </label>
                            <select
                                id="state"
                                name="state"
                                value={selectStateName}
                                className="  border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                                onChange={handleSelectStateChange}
                            >
                                <option value={""} selected disabled></option>
                                {stateList?.map((tz, key) => (
                                    <option key={key} value={tz.stateName}>
                                        {tz.stateName}
                                    </option>
                                ))}
                            </select>
                            <span className="absolute right-4 top-[60px] transform -translate-y-1/2 pointer-events-none p-[6px]">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        </div>
                        <div>
                            <label for="principalInvestigator" class="block title_color pb-4">
                                City
                                {/* <span className="aestrick_color">*</span> */}
                            </label>
                            <input
                                type="text"
                                name="principalInvestigator"
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                // required
                                // placeholder="Please enter city"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                            {errors.city && <span className="text-red-500">{errors.city}</span>}
                        </div>
                        <div>
                            <label for="organization_name" class="block title_color pb-4">
                                Zip Code
                                {/* <span className="aestrick_color">*</span> */}
                            </label>
                            <input
                                type="text"
                                name="organization_name"
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                // required
                                // placeholder="Please enter Postal Code"
                                value={postal}
                                onChange={(e) => setPostal(e.target.value)}
                            />
                            {errors.postal && <span className="text-red-500">{errors.postal}</span>}
                        </div>
                    </div>
                    <div className="w-full pt-8 mb-[75px]">
                        <label for="address" class="block title_color pb-4">
                            Address
                            {/* <span className="aestrick_color">*</span> */}
                        </label>
                        <input
                            type="text"
                            name="address"
                            className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                            // required
                            // placeholder="Please enter Address"
                            value={addAddress}
                            onChange={(e) => setAddAddress(e.target.value)}
                        />
                        {errors.address && <span className="text-red-500">{errors.address}</span>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditPatient;
